<template>
  <div class="table-responsive">
    <div class="container-table">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th nowrap class="text-center" width="50">Alterado por</th>
            <th nowrap class="text-center" width="10">Ação</th>
            <th nowrap class="text-center" width="50">Campos alterados</th>
            <th nowrap class="text-center" width="10">Data</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="group in groups">
            <tr data-toggle="collapse" :data-target="'#fields' + group.id" class="clickable pointer" :key="group.id">
              <td class="text-center">{{ (group.user && group.user.name) || '' }}</td>
              <td class="text-center">{{ getGroupEvents(group) }}</td>
              <td class="text-center">{{ getGroupFields(group.rows) }}</td>
              <td class="text-center" nowrap>{{ group.created_at | datetimeMinuteUtcToBr }}</td>
            </tr>
            <tr class="collapse out" :id="'fields' + group.id" :key="'values' + group.id">
              <td colspan="4">
                <CustomerContractHistoryValuesTable :rows="group.rows" />
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <PaginatorBottom
      :from="data.from"
      :to="data.to"
      :total="data.total"
      :current_page="data.current_page"
      :last_page="data.last_page"
      @setPage="setPage"
    />
  </div>
</template>

<script>
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin.js';
import { baseApiUrl } from '@/global';
import axios from 'axios';
import CustomerContractHistoryValuesTable from '@/components/contracts/CustomerContractHistoryValuesTable';
import { contractHistoryMixin } from '@/mixins/contractHistoryMixin';
import PaginatorBottom from '@/components/template/paginator/Bottom.vue';

export default {
  mixins: [returnMessageFormMixin, contractHistoryMixin],
  name: 'CustomerContractHistory',
  components: { CustomerContractHistoryValuesTable, PaginatorBottom },
  data() {
    return {
      data: {},
      page: 1,
      amount: 10,
    };
  },
  methods: {
    getGroupEvents(group) {
      const eventFilter = this.$options.filters.audit_event;
      return [...new Set(group.events.map((event) => eventFilter(event)))].join(', ');
    },
    getGroupFields(rows) {
      return [...new Set(rows.map((row) => row.label))].join(' | ') || '-';
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}&amount=${this.amount}`;
      return filters;
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/audits/contract/${this.contractId}/${this.convertFilters()}`;
      axios(url).then((res) => {
        this.data = res.data;
      });
    },
    setPage(page) {
      if (page < 1 || page > this.data.last_page || page === this.data.current_page) {
        return;
      }
      this.page = page;
      this.getDatas();
    },
  },
  beforeMount() {
    this.loadHistoryLookups();
    if (this.contractId) {
      this.getDatas();
    }
  },
  computed: {
    groups() {
      return (this.data.data || []).map((group) => ({
        ...group,
        rows: this.buildHistoryRows(group.audits),
      }));
    },
    contractId() {
      return this.$store.state.showContractSave;
    },
  },
};
</script>
